import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useCookies } from 'react-cookie';
import { useQueryClient } from 'react-query';
import { SPARK_ROUTES } from 'constants/routes';

type ProtectedRoutesTypes = {
  children: React.ReactNode;
};

function ProtectedRoutes({ children }: ProtectedRoutesTypes) {
  const [cookies] = useCookies();
  const { pathname, search } = useLocation();
  const queryClient = useQueryClient();
  const token = cookies.userToken;
  const navigate = useNavigate();
  React.useEffect(() => {
    if (!token) {
      queryClient.clear();
      navigate(`${SPARK_ROUTES.LOGIN}?${pathname}${search}`);
    }
  }, [token, navigate, queryClient, cookies, pathname, search]);

  if (!token) return null;
  return <>{children}</>;
}

export default ProtectedRoutes;
